import React from 'react';
import { Upload, Cpu, CheckCircle } from 'lucide-react';
export function Process() {
  const steps = [{
    id: '01',
    title: 'Input',
    description: 'Grundriss, Fotos oder Skizzen hochladen.',
    icon: Upload
  }, {
    id: '02',
    title: 'KI-Visualisierung',
    description: 'Unser System erstellt hyperrealistische Renderings.',
    icon: Cpu
  }, {
    id: '03',
    title: 'Lieferung',
    description: 'Fertige Visuals in 48h, druckfertig und web-optimiert.',
    icon: CheckCircle
  }];
  return <section id="process" className="py-24 bg-white" data-id="element-198">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-199">
        <div className="text-center mb-16" data-id="element-200">
          <h2 className="text-3xl sm:text-4xl font-semibold text-black mb-4" data-id="element-201">
            Der Prozess
          </h2>
          <p className="font-light text-neutral-500" data-id="element-202">
            Von der Skizze zum High-End Rendering in drei einfachen Schritten.
          </p>
        </div>

        <div className="relative" data-id="element-203">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-px bg-neutral-200 -z-10 transform -translate-y-1/2" data-id="element-204"></div>

          <div className="grid md:grid-cols-3 gap-12" data-id="element-205">
            {steps.map(step => <div key={step.id} className="relative flex flex-col items-center text-center p-4" data-id="element-206">
                <div className="w-24 h-24 rounded-full bg-white border border-neutral-200 flex items-center justify-center mb-6" data-id="element-207">
                  <step.icon className="w-8 h-8 text-black" data-id="element-208" />
                </div>
                <div className="absolute top-0 right-1/2 translate-x-1/2 -translate-y-4 bg-black text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-209">
                  {step.id}
                </div>
                <h3 className="text-xl font-medium text-black mb-3" data-id="element-210">
                  {step.title}
                </h3>
                <p className="font-light text-neutral-500 max-w-xs" data-id="element-211">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}